import type { Party, Phase, Policy, Power, Role, WinReason } from '../shared/index.js';

export const s = {
  name: 'Secret Hitler',
  pitch: 'Liberaller ve faşistler; gizli Hitler’i bul ya da şansölye yap',
  role: { liberal: 'Liberal', fascist: 'Faşist', hitler: 'Hitler' } satisfies Record<Role, string>,
  party: { liberal: 'Liberal', fascist: 'Faşist' } satisfies Record<Party, string>,
  policy: { liberal: 'Liberal', fascist: 'Faşist' } satisfies Record<Policy, string>,
  power: {
    peek: 'Politika önizleme',
    investigate: 'Sadakat sorgulama',
    specialElection: 'Özel seçim',
    execution: 'İdam',
  } satisfies Record<Power, string>,
  powerHint: {
    peek: 'Başkan destenin üstündeki 3 kartı görür.',
    investigate: 'Başkan bir oyuncunun partisini öğrenir.',
    specialElection: 'Başkan sıradaki başkanı seçer.',
    execution: 'Başkan bir oyuncuyu oyundan çıkarır.',
  } satisfies Record<Power, string>,
  settings: {
    roles: 'Rol dağılımı',
    rolesHint: (n: number) =>
      n >= 5 && n <= 10 ? `Odada ${n} kişi var.` : 'Oyun 5–10 kişiyle oynanır.',
    players: 'Kişi',
    track: 'Faşist pistindeki yetkiler',
    skipAfter: 'Bekleyen oyuncuyu atlama',
    skipHint: 'Bu süreden sonra oda sahibi, sırası gelen oyuncu adına varsayılanı uygulayabilir. Bağlantısı kopan oyuncu hemen atlanabilir.',
    sec: (n: number) => (n < 60 ? `${n} sn` : `${n / 60} dk`),
    readOnly: 'Ayarları oda sahibi seçer.',
  },
  play: {
    you: 'sen',
    president: 'Başkan',
    chancellor: 'Şansölye',
    nominee: 'Aday',
    dead: 'İdam edildi',
    deadShort: 'İdam',
    voted: 'Oy verdi',
    ja: 'Ja!',
    nein: 'Nein',
    table: 'Masa',
    turn: (n: number) => `${n}. hükümet`,
    roleHold: 'Rolünü görmek için basılı tut',
    roleHoldHint: 'Yanındakiler görmesin diye yalnızca basılıyken açılır.',
    roleTeam: 'Takım arkadaşların',
    roleLiberal: 'Liberal yasaları çıkar ya da Hitler’i idam et. Kimin ne olduğunu bilmiyorsun.',
    roleFascist: 'Görevin 6 faşist yasa çıkarmak ya da 3 faşist yasadan sonra Hitler’i şansölye seçtirmek.',
    roleHitlerBlind: 'Faşistler seni tanıyor ama sen onları tanımıyorsun. Güven kazan, şansölye seçil.',
    roleHitlerKnows: 'Görevin 3 faşist yasadan sonra şansölye seçilmek. Liberal gibi davran.',
    investigations: 'Sorgulama sonuçların',
    investigated: (nick: string, party: string) => `${nick}: ${party}`,
    liberalTrack: 'Liberal yasalar',
    trackCount: (label: string, n: number, max: number) => `${label} · ${n}/${max}`,
    pileInfo: (deck: number, discard: number) => `Deste ${deck} · Iskarta ${discard}`,
    hitlerSlot: 'Hitler bölgesi başlangıcı',
    seats: 'Oyuncular',
    fascistTrack: 'Faşist yasalar',
    hitlerZone: '3 faşist yasadan sonra Hitler şansölye seçilirse faşistler kazanır.',
    vetoZone: '5 faşist yasadan sonra veto açılır.',
    tracker: 'Seçim sayacı',
    trackerHint: '3 başarısız seçimde destenin üstündeki yasa kendiliğinden çıkar.',
    deck: 'Deste',
    discard: 'Iskarta',
    // Aday gösterme
    nominateTitle: 'Şansölye adayını seç',
    nominateHint: 'Son seçilen başkan ve şansölye aday olamaz.',
    nominateHint5: 'Son seçilen şansölye aday olamaz.',
    nominate: (nick: string) => `${nick} adayım`,
    waitNominate: (nick: string) => `${nick} şansölye adayını seçiyor.`,
    // Oylama
    voteTitle: (p: string, c: string) => `Başkan ${p}, şansölye ${c} olsun mu?`,
    voteHint: 'Oylar herkes oy verince birlikte açılır.',
    roleOpen: (role: string, blurb: string) => `${role} · ${blurb}`,
    voteMine: (v: string) => `${v} dedin; herkes oy verene kadar değiştirebilirsin.`,
    people: (n: number) => `${n} kişi`,
    voteProgress: (done: number, total: number) => `${done}/${total} oy verildi`,
    deadNoVote: 'İdam edildin; oy veremezsin ama izleyebilirsin.',
    spectator: 'Bu oyunu izliyorsun.',
    voteResult: (passed: boolean) => (passed ? 'Hükümet kuruldu' : 'Hükümet kurulamadı'),
    // Yasama
    silence: 'Yasama sırasında başkan ve şansölye kartlar hakkında konuşmaz, işaret vermez. Sonrasında istediklerini söyleyebilirler; yalan da serbest.',
    presidentTitle: 'Atılacak kartı seç',
    presidentHint: 'Kalan iki kart şansölyeye gider.',
    discardThis: 'Bu kartı at',
    chancellorTitle: 'Yasalaşacak kartı seç',
    chancellorHint: 'Diğer kart ıskartaya gider.',
    enactThis: 'Bu yasayı çıkar',
    veto: 'Veto öner',
    vetoHint: 'Başkan kabul ederse iki kart da atılır ve seçim sayacı ilerler.',
    vetoWait: 'Veto önerdin. Başkanın cevabı bekleniyor.',
    vetoDeniedNote: 'Başkan vetoyu reddetti; bir yasa seçmelisin.',
    vetoAsk: (nick: string) => `${nick} veto öneriyor.`,
    vetoAccept: 'Vetoyu kabul et',
    vetoReject: 'Reddet',
    waitPresident: (nick: string) => `Başkan ${nick} kartlara bakıyor.`,
    waitChancellor: (nick: string) => `Şansölye ${nick} yasayı seçiyor.`,
    waitVeto: (p: string, c: string) => `${c} veto önerdi; başkan ${p} karar veriyor.`,
    // Yetkiler
    powerTitle: (power: string) => power,
    peekTitle: 'Destenin üstündeki 3 kart',
    peekHint: 'Sıradaki yasalar bu sırayla çekilecek. Ne gördüğünü söyleyip söylememek sana kalmış.',
    peekDone: 'Gördüm, devam et',
    investigateTitle: 'Kimin partisini öğrenmek istiyorsun?',
    investigateHint: 'Sonucu yalnızca sen görürsün. Hitler faşist görünür. Daha önce sorgulanan seçilemez.',
    specialTitle: 'Sıradaki başkanı seç',
    specialHint: 'Bu hükümetten sonra sıra senin solundan devam eder.',
    executionTitle: 'Kimi idam ediyorsun?',
    executionHint: 'İdam edilen Hitler’se liberaller kazanır. Değilse rolü açıklanmaz.',
    pick: (nick: string) => `${nick} seç`,
    waitPower: (nick: string, power: string) => `Başkan ${nick}: ${power.toLocaleLowerCase('tr-TR')}.`,
    // Atlama
    skip: (nicks: string) => `${nicks} adına varsayılanı uygula`,
    skipIn: (sec: number) => `${sec} sn sonra atlayabilirsin`,
    skipHint: 'Oy vermeyen Nein sayılır; aday ve kart rastgele seçilir; yetki kullanılmadan geçilir.',
    waiting: (nicks: string) => `Bekleniyor: ${nicks}`,
    // Sonuç
    winner: { liberal: 'Liberaller kazandı', fascist: 'Faşistler kazandı' } satisfies Record<Party, string>,
    noWinner: 'Oyun yarıda bitti',
    reason: {
      liberalPolicies: '5 liberal yasa çıktı.',
      hitlerExecuted: 'Hitler idam edildi.',
      fascistPolicies: '6 faşist yasa çıktı.',
      hitlerChancellor: 'Hitler şansölye seçildi.',
      ended: 'Oda sahibi oyunu bitirdi.',
    } satisfies Record<WinReason, string>,
    rolesTitle: 'Roller',
    backNow: 'Lobiye dön',
    backIn: (sec: number) => `Lobiye dönülüyor… · ${sec} sn`,
    gameOver: 'Oyun bitti',
    winnerTitle: { liberal: 'Liberaller kazandı!', fascist: 'Faşistler kazandı!' } satisfies Record<Party, string>,
    sideLiberal: 'Liberaller',
    sideFascist: 'Faşistler',
    log: 'Olay günlüğü',
  },
  phase: {
    nominate: 'Aday gösterme',
    vote: 'Oylama',
    presidentLegislate: 'Yasama',
    chancellorLegislate: 'Yasama',
    power: 'Yürütme yetkisi',
    over: 'Oyun bitti',
  } satisfies Record<Phase, string>,
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Roller', 'Herkes gizlice rolünü öğrenir. Çoğunluk liberaldir; faşistler birbirini ve Hitler’i tanır. Hitler, 5–6 kişide faşisti tanır, daha kalabalıkta tanımaz.'],
      ['Seçim', 'Başkanlık sırayla döner. Başkan bir şansölye adayı gösterir, herkes aynı anda Ja! ya da Nein der. Çoğunluk Ja! derse hükümet kurulur; kurulamazsa seçim sayacı ilerler.'],
      ['Yasama', 'Başkan desteden 3 kart çeker, birini atar, ikisini şansölyeye verir; şansölye birini yasalaştırır. Bu sırada ikisi de konuşmaz. 5 faşist yasadan sonra veto açılır.'],
      ['Yetkiler', 'Bazı faşist yasalar başkana yetki verir: önizleme, sadakat sorgulama, özel seçim ya da idam. Pistteki simgeler hangisinin geleceğini gösterir.'],
      ['Kazanma', 'Liberaller 5 liberal yasa çıkarınca ya da Hitler idam edilince kazanır. Faşistler 6 faşist yasayla ya da 3 faşist yasadan sonra Hitler şansölye seçilince kazanır.'],
    ] as [string, string][],
    license: {
      before: 'Secret Hitler, Goat, Wolf & Cabbage tarafından ',
      licenseName: 'CC BY-NC-SA 4.0',
      after: ' lisansıyla yayımlanmıştır. Bu ticari olmayan uyarlama aynı lisansla paylaşılır; görseller özgündür, orijinal çizimler kullanılmamıştır. ',
      site: 'secrethitler.com',
    },
  },
};

export const LICENSE_URL = 'https://creativecommons.org/licenses/by-nc-sa/4.0/';
export const SITE_URL = 'https://www.secrethitler.com/';
